export enum ClaimStatus {
    CREATED = "CREATED",
    IN_ANALYSIS = "IN_ANALYSIS",
    PRE_ARBITRATION = "PRE_ARBITRATION",
    ARBITRATION = "ARBITRATION",
    CLOSED = "CLOSED",
    PERMANENTLY_CLOSED = "PERMANENTLY_CLOSED",
    CLOSED_BY_ISSUER = "CLOSED_BY_ISSUER",
}

// 🔹 Dictionary to translate enum values to labels
export const ClaimStatusLabels: Record<ClaimStatus, string> = {
    [ClaimStatus.CREATED]: "Creado",
    [ClaimStatus.IN_ANALYSIS]: "En Analisis",
    [ClaimStatus.PRE_ARBITRATION]: "Pre Arbitraje",
    [ClaimStatus.ARBITRATION]: "Arbitraje",
    [ClaimStatus.CLOSED]: "Cerrado",
    [ClaimStatus.PERMANENTLY_CLOSED]: " Cerrado Permanentemente",
    [ClaimStatus.CLOSED_BY_ISSUER]: "Cerrado por el emisor",
};



